
export const tabDetails =[
  {
    id:1,
    value:'comments'
  },
  {
    id:2,
    value:'files'
  },
  {
    id:3,
    value:'citizens'
  }
]



export const planetDetails =[
  {
    planet_id :1,
    planet_name :'planet_1',
    planet_image:"http://localhost:3100/images/image/planet/planet-09.png"

  },
  {
    planet_id:2,
     planet_name :'planet_2',
     planet_image:"http://localhost:3100/images/image/planet/planet-09.png"
  },
  {
    planet_id:3,
    planet_name :'planet_3',
    planet_image:"http://localhost:3100/images/image/planet/planet-09.png"
  }
]

